<template>
  <div class="FormInput form-group" :class="{ row: horizontal }" :style="marginStyle">
    <!-- <template v-if="horizontal">
      <label :for="uid" class="col-sm-3 col-form-label text-right">{{ label }}</label>
      <div class="col-sm-9">
        <input :id="uid" v-bind="$attrs" class="form-control" :value="value.key" @input="handleInput($event.target.value)" >
      </div>
      <button v-if="value && !$attrs.readonly && !disableClose" type="button" class="close hz-fix" @click="handleClear" tabindex="-1">
        <span>&times;</span>
      </button>
    </template> -->
    <template>
      <transition enter-active-class="animated fadeIn short" leave-active-class="animated fadeout short">
        <label class="formLabel" v-show="value && value.length > 0">{{ label }}</label>
      </transition>
      <el-select
        :popper-append-to-body="false"
        v-if="false"
        popper-class="popper-dropdown"
        v-model="checkedWorkCountry"
        class="phone-prefix-select"
        @change="handleChangeCountry"
        :disabled="disabledInput"
      >
        <el-option
          v-for="item in workCountryData"
          :key="item.id"
          :label="'+' + item.country_code"
          :value="item.id"
        >
          <span>{{ '+' + item.country_code }}&nbsp;{{ item.name_zh }}&nbsp;{{ item.english_name }}</span>
        </el-option>
      </el-select>
      <input
        :id="uid"
        v-bind="$attrs"
        :class="[value && $attrs.type && $attrs.type=== 'password' ? 'pass-spcing' : '', {'pl85': isShowPrefix}, {'disabled-input': disabledInput}]"
        class="form-control text-pd"
        :value="value"
        @input="handleInput($event.target.value)"
      >
      <button v-if="value && !$attrs.readonly && !disableClose" type="button" :class="['close', showEye ? 'hasEyeClose' : '']" @click="handleClear" tabindex="-1">
        <span>&times;</span>
      </button>
      <span class="input-group-addon" v-if="showEye"><i :class="['changePasswordIcon', closeEye ? 'icon_eye_close' : 'icon_eye_open']" @click="viewPassword"></i></span>
    </template>
    <div class="append">
      <slot name="append"></slot>
    </div>
  </div>
</template>

<script>
import marginProps from '@/mixins/marginProps'
// import DictApi from '@/services/dict'
import { mapGetters } from 'vuex'

export default {

  mixins: [marginProps],
  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    label: String,
    value: {
      type: [String, Number, Object]
    },
    disableClose: {
      type: Boolean,
      default: false
    },
    showEye: {
      type: Boolean,
      default: false
    },
    isShowPrefix: {
      type: Boolean,
      default: false
    },
    disabledInput: {
      type: Boolean,
      default: false
    },
    isResetPas: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      closeEye: true,
      checkedWorkCountry: '',
      // workCountryData: []
    }
  },
  computed: {
    uid () {
      return this.label ? this.label + Date.now() : Date.now() + Math.random()
    },
    ...mapGetters(['loggedUser', 'workCountryData'])
  },
  created () {
    this.isShowPrefix && this._getCountryCode()
  },
  mounted () {
  },
  methods: {
    handleInput (value) {
      this.$emit('input', value)
    },
    handleClear () {
      this.$emit('input', '')
    },
    viewPassword () {
      this.closeEye = !this.closeEye
      this.$emit('viewPassword')
    },
    handleChangeCountry (val) {
      this.$emit('changeCountry', val)
    },
    _getCountryCode () {
      this.checkedWorkCountry = 44
      // DictApi.getCountryCode({
      //   cooperation_status: 1
      // }).then(res => {
      //   if (res.ok) {
      //     this.workCountryData = res.data
      //     const obj = res.data.find(item => {
      //       return item.opt_status === 1
      //     })
      //     if (this.isResetPas) {
      //       this.checkedWorkCountry = this.loggedUser.country_id ? +this.loggedUser.country_id : 44
      //     } else {
      //       this.checkedWorkCountry = obj && obj.id
      //     }
      //     this.$emit('changeDeafultCountry', this.checkedWorkCountry)
      //   }
      // })
    }
  }
}
</script>

<style scoped lang="scss">
.FormInput {
  position: relative;
  label {
    font-size: 16px;
    color: #888d9d;
  }
  input {
    font-size: 14px;
    padding-left: 0;
    border: none;
    border-bottom: 1px solid #eee;
    &:focus {
      outline: none;
      box-shadow: none;
    }
    &[readonly] {
      background: transparent;
    }
  }
  .close {
    position: absolute;
    font-weight: normal;
    right: 0px;
    top: 6px;
    outline: none;
  }
  .hasEyeClose {
    right: 25px;
  }
  .hz-fix {
    right: 12px;
  }
  .append {
    position: absolute;
    right: 4px;
    bottom: 6px;
  }
  .formLabel {
    font-size: 14px;
    position: absolute;
    top: -20px;
    left: 0px;
  }
  .input-group-addon {
    position: absolute;
    right: 5px;
    top: 6px;
    height: 21px;
    line-height: 21px;
    display: flex;
    align-items: center;
  }
  .icon_eye_close {
    display: inline-block;
    width: 20px;
    height: 10px;
    margin-top: 3px;
    background-size: 100%;
    background: url(../../assets/icons/eye_close.png) no-repeat;
    background-size: 20px 10px;
  }
  .icon_eye_open {
    display: inline-block;
    width: 22px;
    height: 16px;
    background-size: 100%;
    background: url(../../assets/icons/eye_open.png) no-repeat;
    background-size: 22px 16px;
  }
  .pass-spcing {
    letter-spacing: 8px;
  }
  .phone-prefix-select {
    position: absolute;
    text-align: center;
    font-size: 14px;
    background: transparent;
    &::after {
      content: '';
      position: absolute;
      border-right: 1px solid #E6E6E6;
      height: 24px;
      right: 0;
      top: 0;
      margin: auto;
      bottom: 0;
    }
    /deep/ .el-input__inner {
      border: none;
      text-align: right;
      padding-right: 30px;
      padding-left: 0px;
      background: transparent;
      height: 100%;
    }
    /deep/ .el-select-dropdown {
      background: #F9FBFC;
      width: 3.80rem;
      text-align: left;
    }
    /deep/ .popper__arrow::after {
      border-bottom-color: #F9FBFC;
    }
    /deep/ .el-icon-arrow-up::before {
      border: none;
      width: auto;
      height: auto;
      content: "\e6e1"!important;
    }
    .el-select-dropdown__item {
      font-size: 14px;
      color:#202428;;
      font-weight: 400;
    }
    .el-select-dropdown__item.selected {
      color: #2D5BFF;
    }
  }
  .text-pd {
    // text-indent: 9px;
  }
  /deep/ .disabled-input {
    color: #C0C4CC;
  }
}
// .popper-dropdown {
//   .el-select-dropdown__item {
//     font-size: 14px;
//     color:#202428;;
//     font-weight: 400;
//   }
//   .el-select-dropdown__item.selected {
//     color: #2D5BFF;
//   }
// }
</style>
